export const UiDateFormat = 'dd/MM/yyyy';
export const UiDateTimeFormat = 'dd/MM/yyyy h:mm:ss a';
export const DspxTableDateTimeFormat = `yyyy-MM-dd'T'HH:mm:ss`;
export const DateTimeMinValue = '0001-01-01T00:00:00';

export class OPTION_SETS {

  static readonly maatNcqList = {
    categories: 'categories',
    tradeCodes: 'tradeCodes',
    managerDeterminations: 'managerDeterminations',
    businessPositions: 'businessPositions',
    businessPositionProjectOfficerRecommendations: 'businessPositionProjectOfficerRecommendations',
    contractorPositions: 'contractorPositions'
  } as const;

  static readonly maatNcq = {
    Category: {
      LateCompletion: 'latecompletion',
      Overcharge: 'overcharge',
      DefectiveWorks: 'defectiveworks'
    } as const,

    ContractorPosition: {
      Agreed: 'agreed'
    } as const,

    BusinessPosition: {
      SpoNonSustained: 'spononsustained',
      SpoSustained: 'sposustained'
    } as const,

    ManagerDetermination: {
      SustainedInOneA: 'sustainedinonea',
      SustainedInOneB: 'sustainedinoneb',
      SustainedInTwoA: 'sustainedintwoa',
      SustainedInTwoB: 'sustainedintwob',
      Sustained: 'sustained',
      NonSustained: 'nonsustained',
      NoFurtherActionTaken: 'nofurtheractiontaken'
    }
  } as const;

  static readonly inspectionList = {
    propertyAccess: {
      yesIHaveAccess: 1,
      noAccess: 2
    } as const,

    inspectionStatus: {
      allocated: 1,
      assigned: 2,
      readyForInspection: 3,
      rework: 4,
      inspectionInProgress: 5,
      inspectionComplete: 6,
      readyForReview: 7,
      reviewInProgress: 8,
      reinspect: 9,
      submittedToQA: 10,
      qaInProgress: 11,
      qaAccepted: 12,
      uploadedToHiiP: 13,
      qaRejected: 14,
      deleted: 15,
      pendingUnAssign: 16
    } as const,

    reasonForNoAccess: {
      appointmentNotKept: 1,
      dangerousDog: 2,
      healthAndSafety: 3,
      inspectorAbort: 4,
      none: 5,
      personalSafety: 6,
      propertyDemolished: 7,
      propertyNotLocated: 8,
      propertyVacant: 9,
      restrictedByPropertyCare: 10,
      tenantAvailability: 11,
      tenantNotHome: 12,
      tenantRefusedAccess: 13,
      terminatedByTenant: 14,
      unableToAccessLocation: 15,
      noLikelihoodOfEntry: 16,
    } as const,

    inspectionDateType: {
      targetedInspectionDate: 'targetedinspectiondate',
      inspectionPeriodEndDate: 'inspectionperiodenddate'
    } as const,

    saveActionType: {
      approve: 'approve',
      reject: 'reject'
    } as const

  } as const;

  static readonly calendarEventType = {
    inspection: 'inspection',
    inspectionClientContacted: 'inspectionClientContacted'
  } as const;

  static readonly yesNo = {
    yes: 1,
    no: 2
  } as const;
};

export class OPTION_SET_NAMES {

  static readonly yesNoWithDescription = {
    yes: 'yes',
    no: 'no'
  } as const;

  static readonly uploadedNotUploaded = {
    uploaded: 'uploaded',
    notUploaded: 'notUploaded'
  } as const;

  static readonly inspectionList = {
    reasonForNoAccess: 'reasonForNoAccess'
  } as const;
}

export class OPTION_SET_DESCRIPTIONS {
  static readonly inspectionList = {
    inspectionStatus: {
      allocated: 'Allocated',
      assigned: 'Assigned',
      readyForInspection: 'For Inspection',
      rework: 'Rework',
      inspectionInProgress: 'In Progress',
      inspectionComplete: 'Complete',
      readyForReview: 'For Review',
      reviewInProgress: 'In Review',
      reinspect: 'Reinspect',
      submittedToQA: 'Submitted',
      qaInProgress: 'In QA',
      qaAccepted: 'Accepted',
      uploadedToHiiP: 'Uploaded',
      qaRejected: 'Rejected',
      deleted: 'Deleted',
      pendingUnAssign: 'Pend Unassign'
    } as const,
  } as const;
};

export class SAVE_RESULT_STATUS {
  static readonly common = {
    noMatchingRow: 'NoMatchingRow',
    updatedSinceReadTime: 'UpdatedSinceReadTime',
    success: 'Success',
    insertFailed: 'InsertFailed',
    updateFailed: 'UpdateFailed',
    duplicateRow: 'DuplicateRow',
    invalidAction: 'InvalidAction',
    duplicateChildEntity: 'DuplicateChildEntity',
  } as const;

  static readonly inspection = {
    noMatchingRow: 1,
    inspectionUpdatedSinceReadTime: 2,
    success: 3,
    maxAppointmentsExceeded: 4
  } as const;

  static readonly bulkInspection = {
    failed: 1,
    success: 2
  } as const;
}

export class NAV_TAB_NUMBERS {
  static readonly dashboardCommon = {
    grid: 1,
  } as const;

  static readonly maatAuditPlanList = {
    maatAuditPlans: 1
  } as const;

  static readonly maatJobList = {
    maatAuditPlan: 1,
    maatJobs: 2,
    maatJobItems: 3,
    maatNcqs: 4
  } as const;

  static readonly maatJobItemList = {
    maatJob: 1,
    maatJobItems: 2,
    maatNcqs: 3,
    maatPropertyHistories: 4
  } as const;

  static readonly maatNcqList = {
    maatJobItem: 1,
    maatNcqs: 2
  } as const;

  static readonly maatNcq = {
    maatNcq: 1
  } as const;

  static readonly maatUserList = {
    maatUsers: 1
  } as const;

  static readonly maatUser = {
    maatUser: 1
  } as const;

  static readonly maatSorDescriptionList = {
    maatSorDescriptions: 1
  } as const;

  static readonly organisationList = {
    organisations: 1
  } as const;

  static readonly teamList = {
    teams: 1
  } as const;

  static readonly team = {
    navTabPlaceholder: 1,
  } as const;

  static readonly userList = {
    users: 1
  } as const;

  static readonly inspectionList = {
    formNavigation: 1,
    inspections: 2
  } as const;

  static readonly reportList = {
    businessProgress: 1,
    invoicingSummary: 2
  } as const;

  static readonly auditList = {
    audit: 1
  } as const;

  static readonly batchList = {
    batch: 1
  } as const;

  static readonly syncEntityList = {
    syncEntities: 1
  } as const;

  static readonly inspectionCalendar = {
    inspectionCalendar: 1,
  } as const;
};

export class PAGE_NUMBERS {
  static readonly dashboardCommon = {
    grid: 1,
  } as const;

  static readonly maatAuditPlanList = {
    maatAuditPlans: 1
  } as const;

  static readonly maatJobList = {
    maatAuditPlan: 1,
    maatJobs: 1,
    maatJobItems: 1,
    maatNcqs: 1
  } as const;

  static readonly maatJobItemList = {
    maatJob: 1,
    maatJobItems: 1,
    maatNcqs: 1,
    maatPropertyHistories: 1
  } as const;

  static readonly maatNcqList = {
    maatJobItem: 1,
    maatNcqs: 1
  } as const;

  static readonly maatNcq = {
    maatNcq: 1
  } as const;

  static readonly maatUserList = {
    maatUsers: 1
  } as const;

  static readonly maatUser = {
    maatUser: 1
  } as const;

  static readonly maatSorDescriptionList = {
    maatSorDescriptions: 1
  } as const;

  static readonly organisationList = {
    organisations: 1
  } as const;

  static readonly teamList = {
    teams: 1
  } as const;

  static readonly team = {
    pagePlaceholder: 1,
  } as const;

  static readonly userList = {
    users: 1
  } as const;

  static readonly inspectionList = {
    formNavigation: 1,
    inspections: 1
  } as const;

  static readonly reportList = {
    businessProgress: 1,
    invoicingSummary: 1
  } as const;

  static readonly auditList = {
    audit: 1
  } as const;

  static readonly batchList = {
    batch: 1
  } as const;

  static readonly syncEntityList = {
    syncEntities: 1
  } as const;

  static readonly inspectionCalendar = {
    inspectionCalendar: 1
  } as const;
};

export class SECTION_CODES {
  static readonly maatAuditPlanList = {
    maatAuditPlan: 'maatAuditPlan'
  } as const;

  static readonly maatJobList = {
    maatAuditPlanDetails: 'maatAuditPlanDetails',
    maatJob: 'maatJob',
    maatJobItem: 'maatJobItem',
    maatNcq: 'maatNcq'
  } as const;

  static readonly maatJobItemList = {
    maatJobDetails: 'maatJobDetails',
    maatJobItem: 'maatJobItem',
    maatNcq: 'maatNcq',
    maatPropertyHistory: 'maatPropertyHistory'
  } as const;

  static readonly maatNcqList = {
    maatNcq: 'maatNcq'
  } as const;

  static readonly maatNcq = {
    maatNcqDetailsRaiseNcqSection: 'maatNcqDetailsRaiseNcqSection',
    maatNcqDetailsContractorResponseSection: 'maatNcqDetailsContractorResponseSection',
    maatNcqDetailsPoSpoRecommendationSection: 'maatNcqDetailsPoSpoRecommendationSection',
    maatNcqDetailsSpoResponseSection: 'maatNcqDetailsSpoResponseSection',
    maatNcqDetailsHcAdditionalInfoSection: 'maatNcqDetailsHcAdditionalInfoSection',
    maatNcqDetailsSpoRecommendationSection: 'maatNcqDetailsSpoRecommendationSection',
    maatNcqDetailsManagerDeterminationSection: 'maatNcqDetailsManagerDeterminationSection'
  } as const;

  static readonly maatUserList = {
    maatUsers: 'maatUsers'
  } as const;

  static readonly maatSorDescriptionList = {
    maatSorDescriptions: 'maatSorDescriptions'
  } as const;

  static readonly organisationList = {
    organisation: 'organisation'
  } as const;

  static readonly teamList = {
    team: 'team'
  } as const;

  static readonly team = {
    teamSection: 'teamdetails',
  } as const;

  static readonly userList = {
    user: 'user'
  } as const;

  static readonly inspectionList = {
    inspection: 'inspection'
  } as const;

  static readonly reportList = {
    businessProgressSection: 'businessProgressSection',
    invoicingSummarySection: 'invoicingSummarySection'
  } as const;

  static readonly auditList = {
    inspectionHistory: 'inspectionHistory'
  } as const;

  static readonly batchList = {
    manageBatches: 'manageBatches'
  } as const;

  static readonly syncEntityList = {
    syncEntity: 'syncEntity'
  } as const;

  static readonly inspectionCalendar = {
    inspectionCalendarSectionPlaceholder: 'inspectionCalendarSectionPlaceholder'
  } as const;
};

export class QUESTION_CODES {
  static readonly maatAuditPlanList = {
    maatAuditPlanSearch: 'maatAuditPlanSearch',
    maatAuditPlanPlaceholder: 'maatAuditPlanPlaceholder',
    maatAuditPlanFilter: 'maatAuditPlanFilter'
  } as const;

  static readonly maatJobList = {
    planStatus: 'planStatus',
    planType: 'planType',
    documentation: 'documentation',
    complianceOfficerUserFirstName: 'complianceOfficerUserFirstName',
    complianceOfficerUserLastName: 'complianceOfficerUserLastName',
    complianceOfficerUserEmail: 'complianceOfficerUserEmail',
    complianceOfficerUserContactPhone: 'complianceOfficerUserContactPhone',
    contractorUserFirstName: 'contractorUserFirstName',
    contractorUserLastName: 'contractorUserLastName',
    contractorUserEmail: 'contractorUserEmail',
    contractorUserContactPhone: 'contractorUserContactPhone',
    maatJobSearch: 'maatJobSearch',
    maatJobFilter: 'maatJobFilter',
    maatJobPlaceholder: 'maatJobPlaceholder',
    maatJobItemSearch: 'maatJobItemSearch',
    maatJobItemPlaceholder: 'maatJobItemPlaceholder',
    maatNcqSearch: 'maatNcqSearch',
    maatNcqFilter: 'maatNcqFilter',
    maatNcqPlaceholder: 'maatNcqPlaceholder',
    totalJobsAudited: 'totalJobsAudited',
    mgrSustainedNcqsCount: 'mgrSustainedNcqsCount'
  } as const;

  static readonly maatJobItemList = {
    planStatus: 'planStatus',
    documentation: 'documentation',
    contractorDocumentation: 'contractorDocumentation',
    isNoAccess: 'isNoAccess',
    inspectionDate: 'inspectionDate',
    maatJobItemSearch: 'maatJobItemSearch',
    maatJobItemPlaceholder: 'maatJobItemPlaceholder',
    maatNcqSearch: 'maatNcqSearch',
    maatNcqFilter: 'maatNcqFilter',
    maatNcqPlaceholder: 'maatNcqPlaceholder',
    maatPropertyHistoryPlaceholder: 'maatPropertyHistoryPlaceholder',
    maatPropertyHistorySearch: 'maatPropertyHistorySearch'
  } as const;

  static readonly maatNcqList = {
    maatNcqSearch: 'maatNcqSearch',
    maatNcqFilter: 'maatNcqFilter',
    maatNcqPlaceholder: 'maatNcqPlaceholder'
  } as const;

  static readonly maatNcq = {
    ncqId: 'ncqId',
    ncqStatus: 'ncqStatus',
    dateRaised: 'dateRaised',
    propertyAddress: 'propertyAddress',
    responseRequiredBy: 'responseRequiredBy',
    category: 'category',
    nonConformanceAmount: 'nonConformanceAmount',
    totalItemCostPercentage: 'totalItemCostPercentage',
    description: 'description',
    actionProposed: 'actionProposed',
    tradeCode: 'tradeCode',
    documentation: 'documentation',
    contractorPosition: 'contractorPosition',
    causesConsequences: 'causesConsequences',
    proposedAction: 'proposedAction',
    preventativeMeasures: 'preventativeMeasures',
    contractorDocumentation: 'contractorDocumentation',
    hcNonConformanceAmount: 'hcNonConformanceAmount',
    isContractorLegalAccepted: 'isContractorLegalAccepted',
    businessPositionProjectOfficerRecommendation: 'businessPositionProjectOfficerRecommendation',
    projectOfficerRecommendation: 'projectOfficerRecommendation',
    reInspectFee: 'reInspectFee',
    projectOfficerRecommendationLastUpdatedUserName: 'projectOfficerRecommendationLastUpdatedUserName',
    projectOfficerRecommendationLastUpdatedUserDate: 'projectOfficerRecommendationLastUpdatedUserDate',
    reIssueResponseRequiredBy: 'reIssueResponseRequiredBy',
    seniorProjectOfficerQueryAndComments: 'seniorProjectOfficerQueryAndComments',
    action: 'action',
    seniorProjectOfficerDocumentation: 'seniorProjectOfficerDocumentation',
    contractorAdditionalInfoResponse: 'contractorAdditionalInfoResponse',
    contractorAdditionalInfoDocumentation: 'contractorAdditionalInfoDocumentation',
    contractorAdditionalInfoLastUpdatedUserName: 'contractorAdditionalInfoLastUpdatedUserName',
    contractorAdditionalInfoLastUpdatedUserPosition: 'contractorAdditionalInfoLastUpdatedUserPosition',
    contractorAdditionalInfoLastUpdatedUserDate: 'contractorAdditionalInfoLastUpdatedUserDate',
    seniorProjectOfficerRecommendation: 'seniorProjectOfficerRecommendation',
    seniorProjectOfficerRecommendationLastUpdatedUserName: 'seniorProjectOfficerRecommendationLastUpdatedUserName',
    seniorProjectOfficerRecommendationUpdatedUserDate: 'seniorProjectOfficerRecommendationUpdatedUserDate',
    businessPosition: 'businessPosition',
    managerTradeCode: 'managerTradeCode',
    managerCategory: 'managerCategory',
    managerDetermination: 'managerDetermination',
    managerNonConformanceAmount: 'managerNonConformanceAmount',
    managerComments: 'managerComments',
    managerLastUpdatedUserName: 'managerLastUpdatedUserName',
    managerLastUpdatedUserDate: 'managerLastUpdatedUserDate'
  } as const;

  static readonly maatUserList = {
    maatUsersSearch: 'maatUsersSearch',
    maatUsersFilter: 'maatUsersFilter',
    maatUsersPlaceholder: 'maatUsersPlaceholder'
  } as const;

  static readonly maatSorDescriptionList = {
    maatSorDescriptionsSearch: 'maatSorDescriptionsSearch',
    maatSorDescriptionsPlaceholder: 'maatSorDescriptionsPlaceholder'
  } as const;

  static readonly organisationList = {
    organisationSearch: 'organisationSearch',
    organisationPlaceholder: 'organisationPlaceholder'
  } as const;

  static readonly teamList = {
    teamSearch: 'teamSearch',
    teamPlaceholder: 'teamPlaceholder'
  } as const;

  static readonly team = {
    organisation: 'mtOrganisationId',
  } as const;

  static readonly userList = {
    userSearch: 'userSearch',
    userPlaceholder: 'userPlaceholder'
  } as const;

  static readonly inspectionList = {
    inspectionSearch: 'inspectionSearch',
    inspectionPlaceholder: 'inspectionPlaceholder',
    saveActionType: 'saveActionType',
    photo: 'photo',
    viewPhoto: 'viewPhoto',
    inspectionFilter: 'inspectionFilter'
  } as const;

  static readonly reportList = {
    businessProgressFilter: 'businessProgressFilter',
    businessProgressPlaceholder: 'businessProgressPlaceholder',
    businessProgressTotalPlaceholder: 'businessProgressTotalPlaceholder',
    invoicingSummaryFilter: 'invoicingSummaryFilter',
    invoicingSummaryPlaceholder: 'invoicingSummaryPlaceholder',
    invoicingSummaryTotalPlaceholder: 'invoicingSummaryTotalPlaceholder'
  } as const;

  static readonly auditList = {
    searchPin: 'searchPin'
  } as const;

  static readonly batchList = {
    filterBatches: 'filterBatches'
  } as const;

  static readonly syncEntityList = {
    syncEntitySearch: 'syncEntitySearch',
    syncEntityPlaceholder: 'syncEntityPlaceholder'
  } as const;

  static readonly inspectionCalendar = {
    inspectionCalendarFilter: 'inspectionCalendarFilter',
    inspectionCalendarQuestionPlaceholder: 'inspectionCalendarQuestionPlaceholder'
  } as const;
};

export class QUESTION_PATHS {
  static readonly maatAuditPlanList = {
    search: [
      NAV_TAB_NUMBERS.maatAuditPlanList.maatAuditPlans,
      PAGE_NUMBERS.maatAuditPlanList.maatAuditPlans,
      SECTION_CODES.maatAuditPlanList.maatAuditPlan,
      QUESTION_CODES.maatAuditPlanList.maatAuditPlanSearch
    ],
    filter: [
      NAV_TAB_NUMBERS.maatAuditPlanList.maatAuditPlans,
      PAGE_NUMBERS.maatAuditPlanList.maatAuditPlans,
      SECTION_CODES.maatAuditPlanList.maatAuditPlan,
      QUESTION_CODES.maatAuditPlanList.maatAuditPlanFilter
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatAuditPlanList.maatAuditPlans,
      PAGE_NUMBERS.maatAuditPlanList.maatAuditPlans,
      SECTION_CODES.maatAuditPlanList.maatAuditPlan,
      QUESTION_CODES.maatAuditPlanList.maatAuditPlanPlaceholder
    ]
  } as const;
  static readonly maatJobList = {
    planStatus: [
      NAV_TAB_NUMBERS.maatJobList.maatAuditPlan,
      PAGE_NUMBERS.maatJobList.maatAuditPlan,
      SECTION_CODES.maatJobList.maatAuditPlanDetails,
      QUESTION_CODES.maatJobList.planStatus
    ],
    planType: [
      NAV_TAB_NUMBERS.maatJobList.maatAuditPlan,
      PAGE_NUMBERS.maatJobList.maatAuditPlan,
      SECTION_CODES.maatJobList.maatAuditPlanDetails,
      QUESTION_CODES.maatJobList.planType
    ],
    totalJobsAudited: [
      NAV_TAB_NUMBERS.maatJobList.maatAuditPlan,
      PAGE_NUMBERS.maatJobList.maatAuditPlan,
      SECTION_CODES.maatJobList.maatAuditPlanDetails,
      QUESTION_CODES.maatJobList.totalJobsAudited
    ],
    mgrSustainedNcqsCount: [
      NAV_TAB_NUMBERS.maatJobList.maatAuditPlan,
      PAGE_NUMBERS.maatJobList.maatAuditPlan,
      SECTION_CODES.maatJobList.maatAuditPlanDetails,
      QUESTION_CODES.maatJobList.mgrSustainedNcqsCount
    ],
    search: [
      NAV_TAB_NUMBERS.maatJobList.maatJobs,
      PAGE_NUMBERS.maatJobList.maatJobs,
      SECTION_CODES.maatJobList.maatJob,
      QUESTION_CODES.maatJobList.maatJobSearch
    ],
    filter: [
      NAV_TAB_NUMBERS.maatJobList.maatJobs,
      PAGE_NUMBERS.maatJobList.maatJobs,
      SECTION_CODES.maatJobList.maatJob,
      QUESTION_CODES.maatJobList.maatJobFilter
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatJobList.maatJobs,
      PAGE_NUMBERS.maatJobList.maatJobs,
      SECTION_CODES.maatJobList.maatJob,
      QUESTION_CODES.maatJobList.maatJobPlaceholder
    ],
    jobItemListSearch: [
      NAV_TAB_NUMBERS.maatJobList.maatJobItems,
      PAGE_NUMBERS.maatJobList.maatJobItems,
      SECTION_CODES.maatJobList.maatJobItem,
      QUESTION_CODES.maatJobList.maatJobItemSearch
    ],
    jobItemListPlaceholder: [
      NAV_TAB_NUMBERS.maatJobList.maatJobItems,
      PAGE_NUMBERS.maatJobList.maatJobItems,
      SECTION_CODES.maatJobList.maatJobItem,
      QUESTION_CODES.maatJobList.maatJobItemPlaceholder
    ],
    ncqListSearch: [
      NAV_TAB_NUMBERS.maatJobList.maatNcqs,
      PAGE_NUMBERS.maatJobList.maatNcqs,
      SECTION_CODES.maatJobList.maatNcq,
      QUESTION_CODES.maatJobList.maatNcqSearch
    ],
    ncqListFilter: [
      NAV_TAB_NUMBERS.maatJobList.maatNcqs,
      PAGE_NUMBERS.maatJobList.maatNcqs,
      SECTION_CODES.maatJobList.maatNcq,
      QUESTION_CODES.maatJobList.maatNcqFilter
    ],
    ncqListPlaceholder: [
      NAV_TAB_NUMBERS.maatJobList.maatNcqs,
      PAGE_NUMBERS.maatJobList.maatNcqs,
      SECTION_CODES.maatJobList.maatNcq,
      QUESTION_CODES.maatJobList.maatNcqPlaceholder
    ]
  } as const;
  static readonly maatJobItemList = {
    planStatus: [
      NAV_TAB_NUMBERS.maatJobItemList.maatJob,
      PAGE_NUMBERS.maatJobItemList.maatJob,
      SECTION_CODES.maatJobItemList.maatJobDetails,
      QUESTION_CODES.maatJobItemList.planStatus
    ],
    inspectionDate: [
      NAV_TAB_NUMBERS.maatJobItemList.maatJob,
      PAGE_NUMBERS.maatJobItemList.maatJob,
      SECTION_CODES.maatJobItemList.maatJobDetails,
      QUESTION_CODES.maatJobItemList.inspectionDate
    ],
    isNoAccess: [
      NAV_TAB_NUMBERS.maatJobItemList.maatJob,
      PAGE_NUMBERS.maatJobItemList.maatJob,
      SECTION_CODES.maatJobItemList.maatJobDetails,
      QUESTION_CODES.maatJobItemList.isNoAccess
    ],
    search: [
      NAV_TAB_NUMBERS.maatJobItemList.maatJobItems,
      PAGE_NUMBERS.maatJobItemList.maatJobItems,
      SECTION_CODES.maatJobItemList.maatJobItem,
      QUESTION_CODES.maatJobItemList.maatJobItemSearch
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatJobItemList.maatJobItems,
      PAGE_NUMBERS.maatJobItemList.maatJobItems,
      SECTION_CODES.maatJobItemList.maatJobItem,
      QUESTION_CODES.maatJobItemList.maatJobItemPlaceholder
    ],
    ncqListSearch: [
      NAV_TAB_NUMBERS.maatJobItemList.maatNcqs,
      PAGE_NUMBERS.maatJobItemList.maatNcqs,
      SECTION_CODES.maatJobItemList.maatNcq,
      QUESTION_CODES.maatJobItemList.maatNcqSearch
    ],
    ncqListFilter: [
      NAV_TAB_NUMBERS.maatJobItemList.maatNcqs,
      PAGE_NUMBERS.maatJobItemList.maatNcqs,
      SECTION_CODES.maatJobItemList.maatNcq,
      QUESTION_CODES.maatJobItemList.maatNcqFilter
    ],
    ncqListPlaceholder: [
      NAV_TAB_NUMBERS.maatJobItemList.maatNcqs,
      PAGE_NUMBERS.maatJobItemList.maatNcqs,
      SECTION_CODES.maatJobItemList.maatNcq,
      QUESTION_CODES.maatJobItemList.maatNcqPlaceholder
    ],
    maatPropertyHistorySearch: [
      NAV_TAB_NUMBERS.maatJobItemList.maatPropertyHistories,
      PAGE_NUMBERS.maatJobItemList.maatPropertyHistories,
      SECTION_CODES.maatJobItemList.maatPropertyHistory,
      QUESTION_CODES.maatJobItemList.maatPropertyHistorySearch
    ],
    maatPropertyHistoryPlaceholder: [
      NAV_TAB_NUMBERS.maatJobItemList.maatPropertyHistories,
      PAGE_NUMBERS.maatJobItemList.maatPropertyHistories,
      SECTION_CODES.maatJobItemList.maatPropertyHistory,
      QUESTION_CODES.maatJobItemList.maatPropertyHistoryPlaceholder
    ]
  } as const;
  static readonly maatNcqList = {
    search: [
      NAV_TAB_NUMBERS.maatNcqList.maatNcqs,
      PAGE_NUMBERS.maatNcqList.maatNcqs,
      SECTION_CODES.maatNcqList.maatNcq,
      QUESTION_CODES.maatNcqList.maatNcqSearch
    ],
    filter: [
      NAV_TAB_NUMBERS.maatNcqList.maatNcqs,
      PAGE_NUMBERS.maatNcqList.maatNcqs,
      SECTION_CODES.maatNcqList.maatNcq,
      QUESTION_CODES.maatNcqList.maatNcqFilter
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatNcqList.maatNcqs,
      PAGE_NUMBERS.maatNcqList.maatNcqs,
      SECTION_CODES.maatNcqList.maatNcq,
      QUESTION_CODES.maatNcqList.maatNcqPlaceholder
    ]
  } as const;
  static readonly maatNcq = {
    ncqId: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.ncqId
    ],
    ncqStatus: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.ncqStatus
    ],
    dateRaised: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.dateRaised
    ],
    propertyAddress: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.propertyAddress
    ],
    category: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.category
    ],
    responseRequiredBy: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.responseRequiredBy
    ],
    nonConformanceAmount: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.nonConformanceAmount
    ],
    totalItemCostPercentage: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.totalItemCostPercentage
    ],
    description: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.description
    ],
    actionProposed: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.actionProposed
    ],
    tradeCode: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.tradeCode
    ],
    documentation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsRaiseNcqSection,
      QUESTION_CODES.maatNcq.documentation
    ],
    contractorPosition: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.contractorPosition
    ],
    causesConsequences: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.causesConsequences
    ],
    proposedAction: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.proposedAction
    ],
    preventativeMeasures: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.preventativeMeasures
    ],
    contractorDocumentation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.contractorDocumentation
    ],
    hcNonConformanceAmount: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.hcNonConformanceAmount
    ],
    isContractorLegalAccepted: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsContractorResponseSection,
      QUESTION_CODES.maatNcq.isContractorLegalAccepted
    ],
    businessPositionProjectOfficerRecommendation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsPoSpoRecommendationSection,
      QUESTION_CODES.maatNcq.businessPositionProjectOfficerRecommendation
    ],
    projectOfficerRecommendation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsPoSpoRecommendationSection,
      QUESTION_CODES.maatNcq.projectOfficerRecommendation
    ],
    reInspectFee: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsPoSpoRecommendationSection,
      QUESTION_CODES.maatNcq.reInspectFee
    ],
    projectOfficerRecommendationLastUpdatedUserName: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsPoSpoRecommendationSection,
      QUESTION_CODES.maatNcq.projectOfficerRecommendationLastUpdatedUserName
    ],
    projectOfficerRecommendationLastUpdatedUserDate: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsPoSpoRecommendationSection,
      QUESTION_CODES.maatNcq.projectOfficerRecommendationLastUpdatedUserDate
    ],
    reIssueResponseRequiredBy: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoResponseSection,
      QUESTION_CODES.maatNcq.reIssueResponseRequiredBy
    ],
    seniorProjectOfficerQueryAndComments: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoResponseSection,
      QUESTION_CODES.maatNcq.seniorProjectOfficerQueryAndComments
    ],
    action: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoResponseSection,
      QUESTION_CODES.maatNcq.action
    ],
    seniorProjectOfficerDocumentation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoResponseSection,
      QUESTION_CODES.maatNcq.seniorProjectOfficerDocumentation
    ],
    contractorAdditionalInfoResponse: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsHcAdditionalInfoSection,
      QUESTION_CODES.maatNcq.contractorAdditionalInfoResponse
    ],
    contractorAdditionalInfoDocumentation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsHcAdditionalInfoSection,
      QUESTION_CODES.maatNcq.contractorAdditionalInfoDocumentation
    ],
    contractorAdditionalInfoLastUpdatedUserName: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsHcAdditionalInfoSection,
      QUESTION_CODES.maatNcq.contractorAdditionalInfoLastUpdatedUserName
    ],
    contractorAdditionalInfoLastUpdatedUserPosition: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsHcAdditionalInfoSection,
      QUESTION_CODES.maatNcq.contractorAdditionalInfoLastUpdatedUserPosition
    ],
    contractorAdditionalInfoLastUpdatedUserDate: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsHcAdditionalInfoSection,
      QUESTION_CODES.maatNcq.contractorAdditionalInfoLastUpdatedUserDate
    ],
    seniorProjectOfficerRecommendation: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoRecommendationSection,
      QUESTION_CODES.maatNcq.seniorProjectOfficerRecommendation
    ],
    businessPosition: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoRecommendationSection,
      QUESTION_CODES.maatNcq.businessPosition
    ],
    seniorProjectOfficerRecommendationLastUpdatedUserName: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoRecommendationSection,
      QUESTION_CODES.maatNcq.seniorProjectOfficerRecommendationLastUpdatedUserName
    ],
    seniorProjectOfficerRecommendationUpdatedUserDate: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsSpoRecommendationSection,
      QUESTION_CODES.maatNcq.seniorProjectOfficerRecommendationUpdatedUserDate
    ],
    managerTradeCode: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerTradeCode
    ],
    managerCategory: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerCategory
    ],
    managerDetermination: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerDetermination
    ],
    managerNonConformanceAmount: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerNonConformanceAmount
    ],
    managerComments: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerComments
    ],
    managerLastUpdatedUserName: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerLastUpdatedUserName
    ],
    managerLastUpdatedUserDate: [
      NAV_TAB_NUMBERS.maatNcq.maatNcq,
      PAGE_NUMBERS.maatNcq.maatNcq,
      SECTION_CODES.maatNcq.maatNcqDetailsManagerDeterminationSection,
      QUESTION_CODES.maatNcq.managerLastUpdatedUserDate
    ]
  } as const;
  static readonly maatUserList = {
    search: [
      NAV_TAB_NUMBERS.maatUserList.maatUsers,
      PAGE_NUMBERS.maatUserList.maatUsers,
      SECTION_CODES.maatUserList.maatUsers,
      QUESTION_CODES.maatUserList.maatUsersSearch
    ],
    filter: [
      NAV_TAB_NUMBERS.maatUserList.maatUsers,
      PAGE_NUMBERS.maatUserList.maatUsers,
      SECTION_CODES.maatUserList.maatUsers,
      QUESTION_CODES.maatUserList.maatUsersFilter
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatUserList.maatUsers,
      PAGE_NUMBERS.maatUserList.maatUsers,
      SECTION_CODES.maatUserList.maatUsers,
      QUESTION_CODES.maatUserList.maatUsersPlaceholder
    ]
  } as const;
  static readonly maatSorDescriptionList = {
    search: [
      NAV_TAB_NUMBERS.maatSorDescriptionList.maatSorDescriptions,
      PAGE_NUMBERS.maatSorDescriptionList.maatSorDescriptions,
      SECTION_CODES.maatSorDescriptionList.maatSorDescriptions,
      QUESTION_CODES.maatSorDescriptionList.maatSorDescriptionsSearch
    ],
    placeholder: [
      NAV_TAB_NUMBERS.maatSorDescriptionList.maatSorDescriptions,
      PAGE_NUMBERS.maatSorDescriptionList.maatSorDescriptions,
      SECTION_CODES.maatSorDescriptionList.maatSorDescriptions,
      QUESTION_CODES.maatSorDescriptionList.maatSorDescriptionsPlaceholder
    ]
  } as const;
  static readonly auditList = {
    search: [
      NAV_TAB_NUMBERS.auditList.audit,
      PAGE_NUMBERS.auditList.audit,
      SECTION_CODES.auditList.inspectionHistory,
      QUESTION_CODES.auditList.searchPin
    ]
  } as const;
  static readonly batchList = {
    filter: [
      NAV_TAB_NUMBERS.batchList.batch,
      PAGE_NUMBERS.batchList.batch,
      SECTION_CODES.batchList.manageBatches,
      QUESTION_CODES.batchList.filterBatches
    ]
  } as const;
  static readonly inspectionCalendar = {
    filter: [
      NAV_TAB_NUMBERS.inspectionCalendar.inspectionCalendar,
      PAGE_NUMBERS.inspectionCalendar.inspectionCalendar,
      SECTION_CODES.inspectionCalendar.inspectionCalendarSectionPlaceholder,
      QUESTION_CODES.inspectionCalendar.inspectionCalendarFilter
    ],
    calendar: [
      NAV_TAB_NUMBERS.inspectionCalendar.inspectionCalendar,
      PAGE_NUMBERS.inspectionCalendar.inspectionCalendar,
      SECTION_CODES.inspectionCalendar.inspectionCalendarSectionPlaceholder,
      QUESTION_CODES.inspectionCalendar.inspectionCalendarQuestionPlaceholder
    ]
  } as const;
  static readonly inspectionList = {
    search: [
      NAV_TAB_NUMBERS.inspectionList.inspections,
      PAGE_NUMBERS.inspectionList.inspections,
      SECTION_CODES.inspectionList.inspection,
      QUESTION_CODES.inspectionList.inspectionSearch
    ],
    filter: [
      NAV_TAB_NUMBERS.inspectionList.inspections,
      PAGE_NUMBERS.inspectionList.inspections,
      SECTION_CODES.inspectionList.inspection,
      QUESTION_CODES.inspectionList.inspectionFilter
    ]
  } as const;
  static readonly organisationList = {
    search: [
      NAV_TAB_NUMBERS.organisationList.organisations,
      PAGE_NUMBERS.organisationList.organisations,
      SECTION_CODES.organisationList.organisation,
      QUESTION_CODES.organisationList.organisationSearch]
  } as const;
  static readonly reportList = {
    bpReportFilter: [
      NAV_TAB_NUMBERS.reportList.businessProgress,
      PAGE_NUMBERS.reportList.businessProgress,
      SECTION_CODES.reportList.businessProgressSection,
      QUESTION_CODES.reportList.businessProgressFilter
    ],
    isReportFilter: [
      NAV_TAB_NUMBERS.reportList.invoicingSummary,
      PAGE_NUMBERS.reportList.invoicingSummary,
      SECTION_CODES.reportList.invoicingSummarySection,
      QUESTION_CODES.reportList.invoicingSummaryFilter
    ],
    bpReport: [
      NAV_TAB_NUMBERS.reportList.businessProgress,
      PAGE_NUMBERS.reportList.businessProgress,
      SECTION_CODES.reportList.businessProgressSection,
      QUESTION_CODES.reportList.businessProgressPlaceholder
    ],
    isReport: [
      NAV_TAB_NUMBERS.reportList.invoicingSummary,
      PAGE_NUMBERS.reportList.invoicingSummary,
      SECTION_CODES.reportList.invoicingSummarySection,
      QUESTION_CODES.reportList.invoicingSummaryPlaceholder
    ],
    bpReportTotals: [
      NAV_TAB_NUMBERS.reportList.businessProgress,
      PAGE_NUMBERS.reportList.businessProgress,
      SECTION_CODES.reportList.businessProgressSection,
      QUESTION_CODES.reportList.businessProgressTotalPlaceholder
    ],
    isReportTotals: [
      NAV_TAB_NUMBERS.reportList.invoicingSummary,
      PAGE_NUMBERS.reportList.invoicingSummary,
      SECTION_CODES.reportList.invoicingSummarySection,
      QUESTION_CODES.reportList.invoicingSummaryTotalPlaceholder
    ]
  } as const;
  static readonly syncEntitylist = {
    search: [
      NAV_TAB_NUMBERS.syncEntityList.syncEntities,
      PAGE_NUMBERS.syncEntityList.syncEntities,
      SECTION_CODES.syncEntityList.syncEntity,
      QUESTION_CODES.syncEntityList.syncEntitySearch
    ]
  } as const;
  static readonly team = {
    organisation: [
      NAV_TAB_NUMBERS.team.navTabPlaceholder,
      PAGE_NUMBERS.team.pagePlaceholder,
      SECTION_CODES.team.teamSection,
      QUESTION_CODES.team.organisation
    ]
  } as const;
  static readonly teamList = {
    search: [
      NAV_TAB_NUMBERS.teamList.teams,
      PAGE_NUMBERS.teamList.teams,
      SECTION_CODES.teamList.team,
      QUESTION_CODES.teamList.teamSearch
    ]
  } as const;
  static readonly userList = {
    search: [
      NAV_TAB_NUMBERS.userList.users,
      PAGE_NUMBERS.userList.users,
      SECTION_CODES.userList.user,
      QUESTION_CODES.userList.userSearch
    ]
  } as const;
}

export class APPLICATION_ROLES {
  static readonly maat = {
    manager: 'MAAT_Manager',
    seniorProjectOfficer: 'MAAT_Senior_Project_Officer',
    projectOfficer: 'MAAT_Project_Officer',
    headContractor: 'MAAT_Head_Contractor'
  } as const;

  static readonly pcr = {
    admin: 'PCR_Admin',
    pasManager: 'PCR_PAS_Manager',
    pasUser: 'PCR_PAS_User',
    vendorManager: 'PCR_Vendor_Manager',
    inspector: 'PCR_Inspector'
  } as const;
}

export class QUESTION_TYPE {
  static readonly file = 'file';
}

export class FILTER_VALUES {
  static readonly inspectionList = {
    filterRange: {
      last180Days: 1,
      last90Days: 2,
      last30Days: 3,
      last7Days: 4,
      today: 5,
      next7Days: 6,
      next30Days: 7,
      next90Days: 8,
      next180Days: 9
    },
    alertDisplay: {
      '1': 'Yes',
      '2': 'No'
    }
  } as const;
}

export class FILTER {
  static readonly maatAuditPlanList = {
    searchTerm: 'searchTerm',
    planStatuses: 'planStatuses',
    oohOffice: 'oohOffice',
    planType: 'planType',
    complianceOfficer: 'complianceOfficer'
  } as const;
  static readonly maatJobList = {
    searchTerm: 'searchTerm',
    ncqStatuses: 'ncqStatuses',
    hasContractorDocumentation: 'hasContractorDocumentation',
    hasBeenInspected: 'hasBeenInspected',
    isNoAccess: 'isNoAccess',
    inspectionDateFrom: 'inspectionDateFrom',
    inspectionDateTo: 'inspectionDateTo',
    suburb: 'suburb'
  } as const;
  static readonly maatJobItemList = {
    searchTerm: 'searchTerm',
    ncqStatuses: 'ncqStatuses'
  } as const;
  static readonly maatNcqList = {
    searchTerm: 'searchTerm',
    ncqStatuses: 'ncqStatuses',
    category: 'category',
    headContractorPosition: 'headContractorPosition',
    businessPosition: 'businessPosition',
    tradeCode: 'tradeCode',
    responseRequiredByFrom:'responseRequiredByFrom',
    responseRequiredByTo: 'responseRequiredByTo'
  } as const;
  static readonly maatPropertyHistoryList = {
    searchTerm: 'searchTerm'
  } as const;
  static readonly inspectionList = {
    searchTerm: 'searchTerm',
    alert: 'alert',
    status: 'status',
    suburb: 'suburb',
    surveyForm: 'surveyForm',
    scheduledOn: 'scheduledOn',
    inspectionPeriodEndScheduledOn: 'inspectionPeriodEndScheduledOn',
    assignedTo: 'assignedTo',
    productTypeCode: 'productTypeCode',
    areaOffice: 'areaOffice'
  } as const;
}

// These are the prefixes for the "legacy" search filters that perform the search by matching against a composite string.
// For example: "PIN:131 Address:20TrustRd Suburb:CARLTON Postcode:3053 SurveyForm:HighRiseBlock HasAlert:NO PropertyType:High-riseblock AreaOffice:Carlton ProductTypeCode:RGS'
// These values have to match the corresponding values used in the back-end to construct those composite string.
export class LEGACY_FILTER_PREFIXES {
  static readonly inspectionList = {
    hasAlert: 'HasAlert:',
    suburb: 'Suburb:',
    productTypeCode: 'ProductTypeCode:',
    areaOffice: 'AreaOffice:',
    surveyForm: 'SurveyForm:'
  } as const;
}

// These GUID constants are used by the file upload/download functionality and must match the corresponding constants on the server side
export class FORM_IDENTIFIERS {
  static readonly maatAuditPlan = {
    documentation: '2622b0ec-36fb-4702-94eb-637e7cf4fe94' // Just a random value
  } as const;
  static readonly maatJob = {
    documentation: '6e48d07c-3e32-46f5-a136-cb5cd43f6b73', // Just a random value
    contractorDocumentation: '4f9a2b1d-8e7c-4a3b-9d2e-1f5c6b7a8d9e' // Just a random value
  } as const;
  static readonly maatNcq = {
    documentation: '185a935d-d24e-45e8-9970-9c44784328d3', // Just a random value
    contractorDocumentation: '7c2f6b91-4e8d-4a63-9d5f-2c1a8b7e4f90', // Just a random value
    seniorProjectOfficerDocumentation: 'cf0dec5e-f3ec-4fcc-a367-748715e6ce61', // Just a random value
    contractorAdditionalInfoDocumentation: '5011aee1-6969-495a-81cf-7f5b14949ec5' // Just a random value
  } as const;
  static readonly inspection = {
    noAccessResponsePhoto: 'da659dc0-f11f-9223-3111-27cb4b9cf024', // Just a random value
    photoDownloadIdentifier: '00000000-0000-0000-0000-000000000000'
    // NOTE: the Inspection form documents use as form identifier the inspection ID bigint value converted to GUID (see GuidParser.fromNumber)
  } as const;
}

export class FORM_DUMMY_IDS {
  static readonly inspectionCalendar = {
    id: 'inspectionCalendar'
  } as const;
}

export class DASHBOARD_EVENT {
  static readonly filter = {
    clear: 'clearFilters'
  }
}

export class DASHBOARD {
  static readonly maatJob = {
    column: {
      totalItems: 'totalItems'
    },
    icons: {
      hasContractorDocumentation: {
        iconClass: 'pi pi-check-circle',
        tooltip: `Contractor's documentation uploaded`
      },
      hasBeenInspected: {
        iconClass: 'pi pi-eye',
        tooltip: 'Job has been inspected'
      },
      noAccess: {
        iconClass: 'pi pi-exclamation-circle',
        tooltip: 'No access'
      }
    }
  }
}
